export default function OpenEndedText() {
  throw new Error(
    'Matrix open ended text question type is not implemented yet!',
  );
}

OpenEndedText.propTypes = {};
